// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dual Screen Settings Page Styles */

.ds-page-container {
  height: calc(100vh - 3.5rem);
  overflow-y: scroll; /* Force scrollbar */
  padding-bottom: 96px;
  margin-top: 3.5rem;
  color: #0f172a; /* slate-900 */
  font-family: "Outfit", "Inter", sans-serif;
  box-sizing: border-box;
  width: 100%;
}

/* Custom scrollbar for full size desktop (width >= 1200px) */
@media (min-width: 1200px) {
  .ds-page-container::-webkit-scrollbar {
    width: 16px;
    display: block;
  }
  .ds-page-container::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .ds-page-container.ds-dark::-webkit-scrollbar-track {
    background: #1b1c23;
  }
  .ds-page-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border: 4px solid #f1f1f1;
    border-radius: 8px;
  }
  .ds-page-container.ds-dark::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border: 4px solid #1b1c23;
    border-radius: 8px;
  }
  .ds-page-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  .ds-page-container.ds-dark::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }
}

/* Custom scrollbar for responsive screens (width < 1200px) */
@media (max-width: 1199px) {
  .ds-page-container::-webkit-scrollbar {
    width: 6px;
    display: block;
  }
  .ds-page-container::-webkit-scrollbar-track {
    background: transparent;
  }
  .ds-page-container::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  .ds-page-container.ds-dark::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 3px;
  }
  .ds-page-container::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }
  .ds-page-container.ds-dark::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.25);
  }
}

.ds-page-container.ds-dark {
  background: radial-gradient(circle at top left, rgba(99, 102, 241, 0.25), transparent 30%),
    radial-gradient(circle at bottom right, rgba(56, 189, 248, 0.2), transparent 28%), #1b1c23;
  color: #f8fafc;
}

/* Header styling */
.ds-page-header-sticky {
  position: relative;
  z-index: 20;
  border-bottom: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 0;
}

.ds-dark .ds-page-header-sticky {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background-color: #1b1c23;
}

.ds-page-header-content {
  margin: 0 auto;
  max-width: 1152px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ds-page-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.ds-page-back-button {
  display: flex;
  height: 40px;
  width: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid #cbd5e1; /* slate-200 */
  background-color: #ffffff;
  color: #475569; /* slate-600 */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.2s;
}

.ds-page-back-button:hover {
  transform: translateY(-2px);
  border-color: #94a3b8;
  color: #0f172a;
}

.ds-dark .ds-page-back-button {
  background-color: #2b2c34;
  border-color: rgba(255, 255, 255, 0.1);
  color: #cbd5e1;
}

.ds-dark .ds-page-back-button:hover {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.25);
}

.ds-page-title {
  font-size: 20px;
  font-weight: 700;
  color: #020617; /* slate-950 */
  letter-spacing: -0.025em;
  margin: 0;
}

.ds-dark .ds-page-title {
  color: #ffffff;
}

/* Enable Customer Display Switch area */
.ds-page-header-right-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 8px 16px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.ds-dark .ds-page-header-right-toggle {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: #2b2c34;
}

.ds-page-toggle-label {
  font-size: 14px;
  font-weight: 500;
  color: #334155; /* slate-700 */
}

.ds-dark .ds-page-toggle-label {
  color: #cbd5e1;
}

.ds-page-switch {
  position: relative;
  display: inline-flex;
  height: 20px;
  width: 36px;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px;
  border: 2px solid transparent;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s;
  background-color: #0860e6; /* active default */
  padding: 0;
  box-sizing: border-box;
}

.ds-page-switch-thumb {
  pointer-events: none;
  display: block;
  height: 16px;
  width: 16px;
  border-radius: 9999px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  transform: translateX(16px);
}

/* Body and Layout styling */
.ds-page-body-container {
  margin: 0 auto;
  max-width: 1152px;
  padding: 32px 24px;
  width: 100%;
}

.ds-page-layout-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 32px;
}

@media (min-width: 1200px) {
  .ds-page-layout-grid {
    grid-template-columns: minmax(0, 1.35fr) 360px;
  }
}

.ds-page-preview-panel {
  overflow: hidden;
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background-color: rgba(255, 255, 255, 0.7);
  padding: 16px;
  box-shadow: 0 30px 80px -32px rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  height: stretch;
}

.ds-dark .ds-page-preview-panel {
  border-color: rgba(255, 255, 255, 0.05);
  background-color: rgba(43, 44, 52, 0.7);
  box-shadow: 0 30px 80px -32px rgba(0, 0, 0, 0.5);
}

/* Live Preview screen header within preview panel */
.ds-page-preview-inner-screen {
  margin-bottom: 16px;
  border-radius: 26px;
  border: 1px solid #e2e8f0;
  background-color: #020617; /* slate-950 */
  padding: 12px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.ds-dark .ds-page-preview-inner-screen {
  border-color: rgba(255, 255, 255, 0.05);
}

.ds-page-preview-header-bar {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
  padding: 12px 16px;
  color: #ffffff;
}

.ds-page-preview-subtitle {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.28em;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
}

.ds-page-preview-title {
  margin: 4px 0 0 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.ds-page-preview-desc {
  margin: 4px 0 0 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.55);
}

.ds-page-preview-status-badge {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid rgba(52, 211, 153, 0.3);
  background-color: rgba(16, 185, 129, 0.15);
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #a7f3d0;
}

/* Simulated display (Aspect ratio 16:10) */
.ds-simulated-monitor {
  position: relative;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #040816;
  box-shadow: 0 40px 80px -32px rgba(15, 23, 42, 0.65);
}

.ds-simulated-glow-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top, rgba(99, 102, 241, 0.45), transparent 36%),
    radial-gradient(circle at bottom right, rgba(14, 165, 233, 0.2), transparent 28%);
  pointer-events: none;
}

.ds-simulated-monitor-content {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #ffffff;
}

.ds-simulated-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.ds-simulated-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ds-simulated-phone-icon-wrap {
  display: flex;
  height: 40px;
  width: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.1);
}

.ds-phone-icon {
  height: 20px;
  width: 20px;
  color: #a5f3fc;
}

.ds-simulated-header-tag {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.28em;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
}

.ds-simulated-header-title {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

.ds-simulated-header-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
  padding: 6px 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.ds-sparkle-icon {
  height: 14px;
  width: 14px;
  color: #67e8f9;
}

/* Simulated screen scrollable body */
.ds-simulated-body {
  min-height: 0;
  flex: 1;
  overflow-y: scroll;
  padding: 16px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) rgba(255, 255, 255, 0.05);
}

.ds-simulated-body::-webkit-scrollbar {
  width: 6px;
}

.ds-simulated-body::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.ds-simulated-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 3px;
}

.ds-simulated-body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}

.ds-simulated-grid {
  display: grid;
  gap: 16px;
}

.ds-simulated-grid.ds-grid-cols-2 {
  grid-template-columns: 1fr 1fr;
}

/* @media (min-width: 992px) {
  .ds-simulated-grid {
    grid-template-columns: 1.05fr 0.95fr;
  }
} */

.ds-simulated-card {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.06);
  padding: 20px;
  box-sizing: border-box;
}

.ds-blur-bg {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.ds-step-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
}

.ds-step-num {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.32em;
  color: rgba(165, 243, 252, 0.7);
  margin: 0;
}

.ds-step-title {
  margin: 8px 0 0 0;
  font-size: 26px;
  font-weight: 600;
  color: #ffffff;
}

.ds-step-desc {
  margin: 8px 0 0 0;
  max-width: 448px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.4;
}

.ds-rewards-badge {
  text-align: right;
  border-radius: 16px;
  border: 1px solid rgba(165, 243, 252, 0.2);
  background-color: rgba(34, 211, 238, 0.1);
  padding: 8px 12px;
  flex-shrink: 0;
}

.ds-rewards-tag {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.28em;
  color: rgba(207, 250, 254, 0.6);
  margin: 0;
}

.ds-rewards-val {
  margin: 4px 0 0 0;
  font-size: 16px;
  font-weight: 600;
  color: #ecfeff;
}

.ds-number-input-preview {
  margin-bottom: 16px;
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 16px 20px;
}

.ds-number-input-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.28em;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
}

.ds-number-input-val {
  margin: 12px 0 0 0;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 0.18em;
  color: #ffffff;
}

/* Keypad Grid layout */
.ds-keypad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.ds-keypad-btn {
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.06);
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.2s;
}

.ds-keypad-btn:hover {
  background-color: rgba(255, 255, 255, 0.12);
}

/* Sidebar Column simulated elements */
.ds-simulated-sidebar-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ds-sidebar-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.28em;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 16px 0;
}

.ds-sidebar-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ds-sidebar-item {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
}

.ds-emerald-card {
  border-color: rgba(52, 211, 153, 0.2);
  background-color: rgba(16, 185, 129, 0.1);
}

.ds-rewards-tag-emerald {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.28em;
  color: #d1fae5;
  margin: 0;
}

.ds-customer-name {
  margin: 8px 0 0 0;
  font-size: 22px;
  font-weight: 600;
  color: #ecfeff;
}

.ds-customer-desc {
  margin: 8px 0 0 0;
  font-size: 15px;
  color: #a7f3d0;
}

.ds-customer-action-bar {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  gap: 12px;
}

.ds-customer-action-prompt {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
}

.ds-continue-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  padding: 8px 16px;
  font-size: 15px;
  font-weight: 500;
  color: #0f172a;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}

.ds-continue-btn:hover {
  background-color: #f1f5f9;
}

.ds-simulated-tip-card {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
  padding: 20px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
}

/* Simulated footer of secondary screen */
.ds-simulated-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.25);
  padding: 12px 16px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.ds-simulated-footer-text {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.65);
}

.ds-simulated-footer-price {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

/* Control Row selectors (Touch / Display Only, Steps) */
.ds-page-control-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 4px;
  margin-top: 16px;
}

.ds-page-control-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ds-control-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 9999px;
  border: 1px solid transparent;
  padding: 8px 16px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
}

.ds-control-btn-active {
  border-color: #0f172a;
  background-color: #0f172a;
  color: #ffffff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.ds-control-btn-inactive {
  border-color: #e2e8f0;
  background-color: #ffffff;
  color: #475569;
}

.ds-control-btn-inactive:hover {
  border-color: #cbd5e1;
  color: #0f172a;
}

.ds-dark .ds-control-btn-inactive {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: #2b2c34;
  color: #cbd5e1;
}

.ds-dark .ds-control-btn-inactive:hover {
  border-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.ds-dark .ds-control-btn-active {
  border-color: #ffffff;
  background-color: #ffffff;
  color: #0f172a;
}

.ds-btn-icon {
  height: 16px;
  width: 16px;
}

.ds-flow-btn {
  border-radius: 9999px;
  border: 1px solid transparent;
  padding: 8px 16px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
}

.ds-flow-btn-active {
  border-color: #c7d2fe;
  background-color: #e0e7ff;
  color: #4338ca;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.ds-flow-btn-inactive {
  border-color: #e2e8f0;
  background-color: #ffffff;
  color: #475569;
}

.ds-flow-btn-inactive:hover {
  border-color: #cbd5e1;
  color: #0f172a;
}

.ds-dark .ds-flow-btn-inactive {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: #2b2c34;
  color: #cbd5e1;
}

.ds-dark .ds-flow-btn-inactive:hover {
  border-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

/* Config cards in right pane */
.ds-config-card {
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background-color: rgba(255, 255, 255, 0.75);
  padding: 24px;
  box-shadow: 0 24px 60px -34px rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  margin-bottom: 24px;
  box-sizing: border-box;
}

.ds-dark .ds-config-card {
  border-color: rgba(255, 255, 255, 0.05);
  background-color: rgba(43, 44, 52, 0.75);
  box-shadow: 0 24px 60px -34px rgba(0, 0, 0, 0.5);
}

.ds-config-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.ds-config-icon-box {
  display: flex;
  height: 44px;
  width: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
}

.ds-indigo-light {
  background-color: #e0e7ff;
  color: #4f46e5;
}

.ds-dark .ds-indigo-light {
  background-color: rgba(79, 70, 229, 0.2);
  color: #a5b4fc;
}

.ds-indigo-dark {
  background-color: #4f46e5;
  color: #ffffff;
}

.ds-slate-light {
  background-color: #f1f5f9;
  color: #475569;
}

.ds-dark .ds-slate-light {
  background-color: rgba(255, 255, 255, 0.05);
  color: #cbd5e1;
}

.ds-header-icon {
  height: 20px;
  width: 20px;
}

.ds-config-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.ds-dark .ds-config-title {
  color: #ffffff;
}

.ds-config-subtitle {
  margin: 4px 0 0 0;
  font-size: 15px;
  color: #64748b;
  line-height: 1.4;
}

.ds-dark .ds-config-subtitle {
  color: #94a3b8;
}

.ds-list-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ds-screen-option-card {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid transparent;
  padding: 16px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
}

.ds-screen-option-card-active {
  border-color: #c7d2fe;
  background-color: rgba(238, 242, 255, 0.8);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.ds-screen-option-card-inactive {
  border-color: #e2e8f0;
  background-color: #ffffff;
}

.ds-screen-option-card-inactive:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.ds-dark .ds-screen-option-card-inactive {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: #2b2c34;
}

.ds-dark .ds-screen-option-card-inactive:hover {
  border-color: rgba(255, 255, 255, 0.25);
  background-color: #1e1f25;
}

.ds-dark .ds-screen-option-card-active {
  border-color: rgba(99, 102, 241, 0.4);
  background-color: rgba(99, 102, 241, 0.1);
}

.ds-option-icon-box {
  display: flex;
  height: 44px;
  width: 44px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
}

.ds-option-svg {
  height: 20px;
  width: 20px;
  color: inherit;
}

.ds-option-info {
  min-width: 0;
  flex: 1;
}

.ds-option-title-text {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.ds-dark .ds-option-title-text {
  color: #ffffff;
}

.ds-option-desc-text {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.45;
}

.ds-dark .ds-option-desc-text {
  color: #94a3b8;
}

/* Upload card dashed styling */
.ds-upload-dashed-card {
  margin-bottom: 16px;
  border-radius: 24px;
  border: 2px dashed #cbd5e1;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
}

.ds-upload-dashed-card:hover {
  background-color: #f1f5f9;
}

.ds-dark .ds-upload-dashed-card {
  border-color: rgba(255, 255, 255, 0.2);
  background-color: rgba(27, 28, 35, 0.7);
}

.ds-dark .ds-upload-dashed-card:hover {
  background-color: #1e1f25;
}

.ds-upload-play-icon-wrap {
  margin: 0 auto 12px auto;
  display: flex;
  height: 48px;
  width: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.ds-dark .ds-upload-play-icon-wrap {
  background-color: rgba(255, 255, 255, 0.1);
}

.ds-upload-svg {
  height: 24px;
  width: 24px;
  color: #0860e6;
}

.ds-dark .ds-upload-svg {
  color: #a5b4fc;
}

.ds-upload-title-text {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
}

.ds-dark .ds-upload-title-text {
  color: #ffffff;
}

.ds-upload-desc-text {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #64748b;
}

.ds-dark .ds-upload-desc-text {
  color: #94a3b8;
}

/* Media loops buttons */
.ds-media-option-btn {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  border: 1px solid transparent;
  padding: 12px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.ds-media-option-btn-active {
  border-color: #c7d2fe;
  background-color: rgba(238, 242, 255, 0.8);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.ds-media-option-btn-inactive {
  border-color: #e2e8f0;
  background-color: #ffffff;
}

.ds-media-option-btn-inactive:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.ds-dark .ds-media-option-btn-inactive {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: #2b2c34;
}

.ds-dark .ds-media-option-btn-inactive:hover {
  border-color: rgba(255, 255, 255, 0.25);
  background-color: #1e1f25;
}

.ds-dark .ds-media-option-btn-active {
  border-color: rgba(99, 102, 241, 0.4);
  background-color: rgba(99, 102, 241, 0.1);
}

/* Media preview thumbnail */
.ds-media-preview-thumb {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  flex-shrink: 0;
}

/* Gradients for thumbnails */
.ds-grad-summer {
  background: linear-gradient(135deg, #d946ef, #a855f7, #6366f1);
}

.ds-grad-breakfast {
  background: linear-gradient(135deg, #fbbf24, #f97316, #f43f5e);
}

.ds-grad-chef {
  background: linear-gradient(135deg, #34d399, #2dd4bf, #06b6d4);
}

/* Media details */
.ds-media-info {
  min-width: 0;
  flex: 1;
}

.ds-media-title-text {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

.ds-dark .ds-media-title-text {
  color: #ffffff;
}

.ds-media-desc-text {
  font-size: 12px;
  color: #64748b;
  margin: 4px 0 0 0;
}

.ds-dark .ds-media-desc-text {
  color: #94a3b8;
}

.ds-check-svg {
  width: 20px;
  height: 20px;
  color: #4f46e5;
  flex-shrink: 0;
}

/* Display option switches */
.ds-display-option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 16px;
  cursor: pointer;
  transition: border-color 0.2s;
}

.ds-dark .ds-display-option-row {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: rgba(27, 28, 35, 0.7);
}

.ds-display-option-row:hover {
  border-color: #cbd5e1;
}

.ds-dark .ds-display-option-row:hover {
  border-color: rgba(255, 255, 255, 0.25);
}

.ds-opt-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
}

.ds-dark .ds-opt-title {
  color: #ffffff;
}

.ds-opt-desc {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.ds-dark .ds-opt-desc {
  color: #94a3b8;
}

.ds-option-switch {
  position: relative;
  display: inline-flex;
  height: 20px;
  width: 36px;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px;
  border: 2px solid transparent;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s;
  padding: 0;
  box-sizing: border-box;
}

.ds-option-switch-active {
  background-color: #0860e6;
}

.ds-option-switch-inactive {
  background-color: #cbd5e1;
}

.ds-dark .ds-option-switch-inactive {
  background-color: #475569;
}

.ds-option-switch-thumb {
  pointer-events: none;
  display: block;
  height: 16px;
  width: 16px;
  border-radius: 9999px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.ds-option-switch-thumb-active {
  transform: translateX(16px);
}

.ds-option-switch-thumb-inactive {
  transform: translateX(0);
}

/* Flow Guidance section styling */
.ds-flow-guidance-card {
  border-radius: 28px;
  border: 1px solid #e2e8f0;
  background-color: #020617;
  padding: 24px;
  color: #ffffff;
  box-shadow: 0 24px 60px -34px rgba(15, 23, 42, 0.58);
  box-sizing: border-box;
}

.ds-dark .ds-flow-guidance-card {
  border-color: rgba(255, 255, 255, 0.05);
}

.ds-guidance-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.ds-guidance-icon-box {
  display: flex;
  height: 44px;
  width: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.1);
}

.ds-star-svg {
  height: 20px;
  width: 20px;
  color: #fcd34d;
}

.ds-guidance-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}

.ds-guidance-subtitle {
  margin: 4px 0 0 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
}

.ds-guidance-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ds-guidance-item {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
  padding: 12px 16px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.5;
}

/* Simulated screen layouts and preview card states */

.ds-promo-card-wrap {
  position: relative;
  overflow: hidden;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px;
  min-height: 300px;
  box-sizing: border-box;
}

.ds-promo-card-bg-gradient {
  position: absolute;
  inset: 0;
  opacity: 0.95;
  pointer-events: none;
}

.ds-promo-card-bg-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    140deg,
    rgba(255, 255, 255, 0.16),
    transparent 42%,
    rgba(15, 23, 42, 0.34)
  );
  pointer-events: none;
}

.ds-promo-card-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 252px;
}

.ds-promo-now-playing-badge {
  display: inline-flex;
  align-self: flex-start;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
}

.ds-promo-main-title {
  margin: 20px 0 12px 0;
  font-size: 40px;
  font-weight: 600;
  line-height: 1.3;
  color: #ffffff;
}

.ds-promo-sub-text {
  margin: 0 0 24px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.45;
}

.ds-promo-media-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background-color: rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.ds-promo-media-tag {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.ds-promo-media-name {
  margin: 4px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}

.ds-promo-media-resolution {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
}

.ds-bullet-cards-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 16px;
}

.ds-bullet-card {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.06);
  padding: 16px 32px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.45;
}

.ds-loyalty-prompt-card {
  border-radius: 24px;
  border: 1px solid rgba(34, 211, 238, 0.2);
  background-color: rgba(34, 211, 238, 0.12);
  padding: 20px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.ds-loyalty-prompt-badge {
  display: inline-flex;
  border-radius: 9999px;
  border: 1px solid rgba(34, 211, 238, 0.2);
  background-color: rgba(34, 211, 238, 0.1);
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.28em;
  color: #cffafe;
  margin-bottom: 12px;
}

.ds-loyalty-prompt-title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.ds-loyalty-prompt-desc {
  font-size: 15px;
  color: rgba(207, 250, 254, 0.75);
  margin: 8px 0 0 0;
  line-height: 1.4;
}

.ds-loyalty-qr-box {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  margin-top: 16px;
}

.ds-loyalty-qr-svg {
  width: 32px;
  height: 32px;
  color: #a5f3fc;
  flex-shrink: 0;
}

.ds-loyalty-qr-text {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
}

.ds-display-only-note-card {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
  padding: 20px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
  box-sizing: border-box;
}

.ds-display-read-only-notice-block {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.45;
  margin-bottom: 16px;
}

/* Keypad updates */
.ds-keypad-btn:active {
  transform: scale(0.97);
}

/* Cart Item layouts */
.ds-cart-order-items-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.ds-cart-order-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
}

.ds-cart-item-thumb {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 16px;
}

.ds-cart-thumb-1 {
  background: linear-gradient(135deg, #fde68a, #fed7aa);
}

.ds-cart-thumb-2 {
  background: linear-gradient(135deg, #fecdd3, #fed7aa);
}

.ds-cart-thumb-3 {
  background: linear-gradient(135deg, #bae6fd, #cffafe);
}

.ds-cart-thumb-4 {
  background: linear-gradient(135deg, #d9f99d, #a7f3d0);
}

.ds-cart-thumb-5 {
  background: linear-gradient(135deg, #f5d0fe, #fecdd3);
}

.ds-cart-item-details {
  flex: 1;
  min-width: 0;
}

.ds-cart-item-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ds-cart-item-name {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ds-cart-item-price {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.ds-cart-item-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

.ds-price-breakdown-card {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.25);
  padding: 16px;
}

.ds-price-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.ds-price-row:last-child {
  margin-bottom: 0;
}

.ds-total-row {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-top: 12px;
}

.ds-cart-linked-loyalty-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(52, 211, 153, 0.2);
  background-color: rgba(16, 185, 129, 0.12);
  padding: 12px 16px;
  margin-bottom: 16px;
  cursor: pointer;
}

.ds-loyalty-linked-title {
  font-size: 14px;
  font-weight: 500;
  color: #a7f3d0;
  margin: 0;
}

.ds-loyalty-linked-desc {
  font-size: 12px;
  color: rgba(209, 250, 229, 0.7);
  margin: 4px 0 0 0;
}

.ds-loyalty-linked-badge {
  inline-flex: true;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.1);
  padding: 2px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
}

/* Payment Flow layouts */
.ds-payment-methods-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.ds-pay-method-btn {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 88px;
  box-sizing: border-box;
}

.ds-pay-method-btn-active {
  border-color: rgba(34, 211, 238, 0.3);
  background-color: rgba(34, 211, 238, 0.15);
  color: #ecfeff;
}

.ds-pay-method-btn-inactive {
  background-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
}

.ds-pay-method-btn-inactive:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.ds-pay-method-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.ds-pay-method-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.ds-pay-method-icon {
  width: 16px;
  height: 16px;
  color: inherit;
}

.ds-pay-method-desc {
  font-size: 12px;
  color: inherit;
  opacity: 0.7;
  margin: 8px 0 0 0;
}

.ds-tips-selection-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.ds-tip-btn {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 12px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
}

.ds-tip-btn-active {
  border-color: rgba(34, 211, 238, 0.3);
  background-color: rgba(34, 211, 238, 0.15);
  color: #ecfeff;
}

.ds-tip-btn-inactive {
  background-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
}

.ds-tip-btn-inactive:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.ds-tip-percent {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.ds-tip-amount {
  font-size: 12px;
  color: inherit;
  opacity: 0.7;
  margin: 4px 0 0 0;
}

/* Scan & Pay components */
.ds-scan-qr-wrap {
  width: 44px;
  height: 44px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ds-scan-qr-svg-icon {
  width: 24px;
  height: 24px;
  color: #a5f3fc;
}

.ds-qr-code-display-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
}

.ds-qr-code-frame {
  padding: 16px;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
}

.ds-qr-code-image {
  display: block;
}

.ds-qr-scan-hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  margin-top: 12px;
  text-align: center;
}

/* Success layout components */
.ds-simulated-success-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 380px;
  box-sizing: border-box;
}

.ds-success-checkmark-wrap {
  border-radius: 9999px;
  border: 1px solid rgba(52, 211, 153, 0.2);
  background-color: rgba(16, 185, 129, 0.12);
  padding: 24px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.ds-success-check-svg {
  width: 56px;
  height: 56px;
  color: #6ee7b7;
}

.ds-success-badge-tag {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.32em;
  color: #a7f3d0;
  margin: 20px 0 0 0;
}

.ds-success-heading {
  font-size: 36px;
  font-weight: 600;
  color: #ffffff;
  margin: 8px 0 0 0;
}

.ds-success-sub-desc {
  max-width: 448px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
  margin: 12px 0 0 0;
  line-height: 1.4;
}

.ds-success-details-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  width: 100%;
  max-width: 448px;
  margin-top: 24px;
}

.ds-success-detail-box {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.06);
  padding: 16px;
}

.ds-success-detail-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.ds-success-detail-val {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  margin: 4px 0 0 0;
}

/* Header styles matching user reference markup */
.ds-hdr-wrap {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  height: 64px;
  max-width: 1152px;
  align-items: center;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;
}

.ds-hdr-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.ds-hdr-back {
  display: flex;
  height: 40px;
  width: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #475569;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
  cursor: pointer;
  box-sizing: border-box;
}

.ds-hdr-back:hover {
  transform: translateY(-2px);
  border-color: #cbd5e1;
  color: #0f172a;
}

.ds-hdr-title {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #020617;
  margin: 0;
}

.ds-dark .ds-hdr-title {
  color: #ffffff;
}

.ds-hdr-right {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 8px 16px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}

.ds-dark .ds-hdr-right {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
}

.ds-hdr-toggle-label {
  font-size: 14px;
  font-weight: 500;
}

.ds-dark .ds-hdr-toggle-label {
  color: #cbd5e1;
}

.ds-hdr-switch {
  position: relative;
  display: inline-flex;
  height: 20px;
  width: 36px;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px;
  border: 2px solid transparent;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s;
  padding: 0;
  box-sizing: border-box;
}

.ds-hdr-switch[data-state="checked"] {
  background-color: #0860e6;
}

.ds-hdr-switch[data-state="unchecked"] {
  background-color: #cbd5e1;
}

.ds-dark .ds-hdr-switch[data-state="unchecked"] {
  background-color: #475569;
}

.ds-hdr-switch-thumb {
  pointer-events: none;
  display: block;
  height: 16px;
  width: 16px;
  border-radius: 9999px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
}

.ds-hdr-switch-thumb[data-state="checked"] {
  transform: translateX(16px);
}

.ds-hdr-switch-thumb[data-state="unchecked"] {
  transform: translateX(0);
}

/* Paused status badge overlay styling */
.ds-status-paused {
  border-color: rgba(255, 255, 255, 0.15) !important;
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: rgba(255, 255, 255, 0.7) !important;
}

/* Display off layout screen */
.ds-display-off-container {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
  color: #ffffff;
  z-index: 5;
  box-sizing: border-box;
}

.ds-display-off-icon-wrap {
  display: flex;
  height: 80px;
  width: 80px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  box-sizing: border-box;
}

.ds-display-off-icon {
  height: 40px;
  width: 40px;
  color: rgba(255, 255, 255, 0.6);
}

.ds-display-off-text-group {
  margin-top: 8px;
}

.ds-display-off-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.ds-display-off-desc {
  max-width: 448px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
  margin: 8px auto 0 auto;
}

/* New Scan & Pay Section Styles */
.ds-scan-pay-layout {
  display: grid;
  gap: 16px;
  grid-template-columns: 1.15fr 0.85fr;
}

@media (max-width: 991px) {
  .ds-scan-pay-layout {
    grid-template-columns: 1fr;
  }
}

.ds-payment-flow-card {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  background-color: rgba(255, 255, 255, 0.06) !important;
  padding: 20px !important;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ds-payment-flow-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.ds-payment-flow-subtitle {
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0.32em;
  color: rgba(255, 255, 255, 0.55) !important;
  margin: 0 !important;
}

.ds-payment-flow-title {
  margin: 8px 0 0 0 !important;
  font-size: 24px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}

.ds-payment-flow-desc {
  margin: 4px 0 0 0 !important;
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.6) !important;
  line-height: 1.5 !important;
}

.ds-payment-flow-wallet-icon {
  height: 32px;
  width: 32px;
  color: #67e8f9;
  flex-shrink: 0;
}

.ds-scan-pay-qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 28px;
  border: 1px solid rgba(34, 211, 238, 0.2);
  background-color: rgba(34, 211, 238, 0.1);
  padding: 24px;
  text-align: center;
  box-sizing: border-box;
}

.ds-scan-pay-qr-frame {
  margin-bottom: 20px;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background-color: #ffffff;
  padding: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 20px 50px -20px rgba(255, 255, 255, 0.4);
  box-sizing: border-box;
}

.ds-scan-pay-qr-code-svg {
  height: 176px;
  width: 176px;
  color: #020617;
}

.ds-scan-pay-qr-subtitle {
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0.32em;
  color: rgba(207, 250, 254, 0.7) !important;
  margin: 0 !important;
}

.ds-scan-pay-qr-title {
  margin: 8px 0 0 0 !important;
  font-size: 30px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}

.ds-scan-pay-qr-desc {
  margin: 8px 0 0 0 !important;
  max-width: 448px;
  font-size: 14px !important;
  color: rgba(236, 254, 255, 0.8) !important;
  line-height: 1.5 !important;
}

.ds-scan-pay-instruction-box {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  text-align: left;
  box-sizing: border-box;
  width: 100%;
}

.ds-scan-pay-mini-qr-icon {
  height: 32px;
  width: 32px;
  color: #a5f3fc;
  flex-shrink: 0;
}

.ds-instruction-title {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  margin: 0 !important;
}

.ds-instruction-subtitle {
  font-size: 12px !important;
  color: rgba(255, 255, 255, 0.6) !important;
  margin: 4px 0 0 0 !important;
}

.ds-scan-pay-sidebar {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ds-sidebar-price-breakdown {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.25);
  padding: 16px;
  box-sizing: border-box;
}

.ds-checkout-notes-card {
  padding: 20px !important;
}

.ds-checkout-notes-list {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ds-checkout-note-item {
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  background-color: rgba(0, 0, 0, 0.15) !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  color: rgba(255, 255, 255, 0.75) !important;
  line-height: 1.5 !important;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/DualScreen/index.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,4BAA4B;EAC5B,kBAAkB,EAAE,oBAAoB;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,cAAc,EAAE,cAAc;EAC9B,0CAA0C;EAC1C,sBAAsB;EACtB,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,qCAAqC;IACrC,kBAAkB;EACpB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;8FAC4F;EAC5F,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB,EAAE,cAAc;EACzC,yBAAyB;EACzB,cAAc,EAAE,cAAc;EAC9B,2CAA2C;EAC3C,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,+CAA+C;EAC/C,iCAAiC;EACjC,yBAAyB,EAAE,mBAAmB;EAC9C,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,oDAAoD;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB,EAAE,cAAc;EACzC,aAAa;EACb,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;qFACmF;EACnF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iDAAiD;EACjD,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;EAC3C,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,oEAAoE;AACtE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;GAIG;;AAEH;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;EACzC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8C;EAC9C,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,oDAAoD;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,+CAA+C;EAC/C,iCAAiC;EACjC,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,qDAAqD;;AAErD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,aAAa;EACb,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,yCAAyC;EACzC,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,0CAA0C;EAC1C,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,+CAA+C;EAC/C,iCAAiC;EACjC,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,kDAAkD;EAClD,sDAAsD;EACtD,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,qDAAqD;EACrD,sDAAsD;EACtD,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;EAC1B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,gDAAgD;EAChD,6BAA6B;EAC7B,0BAA0B;EAC1B,2CAA2C;EAC3C,2BAA2B;AAC7B","sourcesContent":["/* Dual Screen Settings Page Styles */\n\n.ds-page-container {\n  height: calc(100vh - 3.5rem);\n  overflow-y: scroll; /* Force scrollbar */\n  padding-bottom: 96px;\n  margin-top: 3.5rem;\n  color: #0f172a; /* slate-900 */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n/* Custom scrollbar for full size desktop (width >= 1200px) */\n@media (min-width: 1200px) {\n  .ds-page-container::-webkit-scrollbar {\n    width: 16px;\n    display: block;\n  }\n  .ds-page-container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  .ds-page-container.ds-dark::-webkit-scrollbar-track {\n    background: #1b1c23;\n  }\n  .ds-page-container::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border: 4px solid #f1f1f1;\n    border-radius: 8px;\n  }\n  .ds-page-container.ds-dark::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.2);\n    border: 4px solid #1b1c23;\n    border-radius: 8px;\n  }\n  .ds-page-container::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n  }\n  .ds-page-container.ds-dark::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n}\n\n/* Custom scrollbar for responsive screens (width < 1200px) */\n@media (max-width: 1199px) {\n  .ds-page-container::-webkit-scrollbar {\n    width: 6px;\n    display: block;\n  }\n  .ds-page-container::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  .ds-page-container::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n  .ds-page-container.ds-dark::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 3px;\n  }\n  .ds-page-container::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.3);\n  }\n  .ds-page-container.ds-dark::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.25);\n  }\n}\n\n.ds-page-container.ds-dark {\n  background: radial-gradient(circle at top left, rgba(99, 102, 241, 0.25), transparent 30%),\n    radial-gradient(circle at bottom right, rgba(56, 189, 248, 0.2), transparent 28%), #1b1c23;\n  color: #f8fafc;\n}\n\n/* Header styling */\n.ds-page-header-sticky {\n  position: relative;\n  z-index: 20;\n  border-bottom: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 0;\n}\n\n.ds-dark .ds-page-header-sticky {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  background-color: #1b1c23;\n}\n\n.ds-page-header-content {\n  margin: 0 auto;\n  max-width: 1152px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ds-page-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.ds-page-back-button {\n  display: flex;\n  height: 40px;\n  width: 40px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: 1px solid #cbd5e1; /* slate-200 */\n  background-color: #ffffff;\n  color: #475569; /* slate-600 */\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ds-page-back-button:hover {\n  transform: translateY(-2px);\n  border-color: #94a3b8;\n  color: #0f172a;\n}\n\n.ds-dark .ds-page-back-button {\n  background-color: #2b2c34;\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #cbd5e1;\n}\n\n.ds-dark .ds-page-back-button:hover {\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.ds-page-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #020617; /* slate-950 */\n  letter-spacing: -0.025em;\n  margin: 0;\n}\n\n.ds-dark .ds-page-title {\n  color: #ffffff;\n}\n\n/* Enable Customer Display Switch area */\n.ds-page-header-right-toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 8px 16px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n}\n\n.ds-dark .ds-page-header-right-toggle {\n  border-color: rgba(255, 255, 255, 0.1);\n  background-color: #2b2c34;\n}\n\n.ds-page-toggle-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155; /* slate-700 */\n}\n\n.ds-dark .ds-page-toggle-label {\n  color: #cbd5e1;\n}\n\n.ds-page-switch {\n  position: relative;\n  display: inline-flex;\n  height: 20px;\n  width: 36px;\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: background-color 0.2s;\n  background-color: #0860e6; /* active default */\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.ds-page-switch-thumb {\n  pointer-events: none;\n  display: block;\n  height: 16px;\n  width: 16px;\n  border-radius: 9999px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n  transform: translateX(16px);\n}\n\n/* Body and Layout styling */\n.ds-page-body-container {\n  margin: 0 auto;\n  max-width: 1152px;\n  padding: 32px 24px;\n  width: 100%;\n}\n\n.ds-page-layout-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n@media (min-width: 1200px) {\n  .ds-page-layout-grid {\n    grid-template-columns: minmax(0, 1.35fr) 360px;\n  }\n}\n\n.ds-page-preview-panel {\n  overflow: hidden;\n  border-radius: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  background-color: rgba(255, 255, 255, 0.7);\n  padding: 16px;\n  box-shadow: 0 30px 80px -32px rgba(15, 23, 42, 0.28);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  height: stretch;\n}\n\n.ds-dark .ds-page-preview-panel {\n  border-color: rgba(255, 255, 255, 0.05);\n  background-color: rgba(43, 44, 52, 0.7);\n  box-shadow: 0 30px 80px -32px rgba(0, 0, 0, 0.5);\n}\n\n/* Live Preview screen header within preview panel */\n.ds-page-preview-inner-screen {\n  margin-bottom: 16px;\n  border-radius: 26px;\n  border: 1px solid #e2e8f0;\n  background-color: #020617; /* slate-950 */\n  padding: 12px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.ds-dark .ds-page-preview-inner-screen {\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.ds-page-preview-header-bar {\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.05);\n  padding: 12px 16px;\n  color: #ffffff;\n}\n\n.ds-page-preview-subtitle {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.28em;\n  color: rgba(255, 255, 255, 0.45);\n  margin: 0;\n}\n\n.ds-page-preview-title {\n  margin: 4px 0 0 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.ds-page-preview-desc {\n  margin: 4px 0 0 0;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.ds-page-preview-status-badge {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid rgba(52, 211, 153, 0.3);\n  background-color: rgba(16, 185, 129, 0.15);\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #a7f3d0;\n}\n\n/* Simulated display (Aspect ratio 16:10) */\n.ds-simulated-monitor {\n  position: relative;\n  aspect-ratio: 16 / 10;\n  overflow: hidden;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: #040816;\n  box-shadow: 0 40px 80px -32px rgba(15, 23, 42, 0.65);\n}\n\n.ds-simulated-glow-overlay {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at top, rgba(99, 102, 241, 0.45), transparent 36%),\n    radial-gradient(circle at bottom right, rgba(14, 165, 233, 0.2), transparent 28%);\n  pointer-events: none;\n}\n\n.ds-simulated-monitor-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  color: #ffffff;\n}\n\n.ds-simulated-header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.ds-simulated-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ds-simulated-phone-icon-wrap {\n  display: flex;\n  height: 40px;\n  width: 40px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.ds-phone-icon {\n  height: 20px;\n  width: 20px;\n  color: #a5f3fc;\n}\n\n.ds-simulated-header-tag {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.28em;\n  color: rgba(255, 255, 255, 0.45);\n  margin: 0;\n}\n\n.ds-simulated-header-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.85);\n  margin: 0;\n}\n\n.ds-simulated-header-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 9999px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.05);\n  padding: 6px 12px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.ds-sparkle-icon {\n  height: 14px;\n  width: 14px;\n  color: #67e8f9;\n}\n\n/* Simulated screen scrollable body */\n.ds-simulated-body {\n  min-height: 0;\n  flex: 1;\n  overflow-y: scroll;\n  padding: 16px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.25) rgba(255, 255, 255, 0.05);\n}\n\n.ds-simulated-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ds-simulated-body::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n}\n\n.ds-simulated-body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 3px;\n}\n\n.ds-simulated-body::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.ds-simulated-grid {\n  display: grid;\n  gap: 16px;\n}\n\n.ds-simulated-grid.ds-grid-cols-2 {\n  grid-template-columns: 1fr 1fr;\n}\n\n/* @media (min-width: 992px) {\n  .ds-simulated-grid {\n    grid-template-columns: 1.05fr 0.95fr;\n  }\n} */\n\n.ds-simulated-card {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.06);\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.ds-blur-bg {\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.ds-step-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.ds-step-num {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.32em;\n  color: rgba(165, 243, 252, 0.7);\n  margin: 0;\n}\n\n.ds-step-title {\n  margin: 8px 0 0 0;\n  font-size: 26px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.ds-step-desc {\n  margin: 8px 0 0 0;\n  max-width: 448px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.4;\n}\n\n.ds-rewards-badge {\n  text-align: right;\n  border-radius: 16px;\n  border: 1px solid rgba(165, 243, 252, 0.2);\n  background-color: rgba(34, 211, 238, 0.1);\n  padding: 8px 12px;\n  flex-shrink: 0;\n}\n\n.ds-rewards-tag {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.28em;\n  color: rgba(207, 250, 254, 0.6);\n  margin: 0;\n}\n\n.ds-rewards-val {\n  margin: 4px 0 0 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ecfeff;\n}\n\n.ds-number-input-preview {\n  margin-bottom: 16px;\n  border-radius: 22px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 16px 20px;\n}\n\n.ds-number-input-label {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.28em;\n  color: rgba(255, 255, 255, 0.45);\n  margin: 0;\n}\n\n.ds-number-input-val {\n  margin: 12px 0 0 0;\n  font-size: 28px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  color: #ffffff;\n}\n\n/* Keypad Grid layout */\n.ds-keypad-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.ds-keypad-btn {\n  display: flex;\n  height: 56px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.06);\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.ds-keypad-btn:hover {\n  background-color: rgba(255, 255, 255, 0.12);\n}\n\n/* Sidebar Column simulated elements */\n.ds-simulated-sidebar-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ds-sidebar-label {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.28em;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0 0 16px 0;\n}\n\n.ds-sidebar-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ds-sidebar-item {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.ds-emerald-card {\n  border-color: rgba(52, 211, 153, 0.2);\n  background-color: rgba(16, 185, 129, 0.1);\n}\n\n.ds-rewards-tag-emerald {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.28em;\n  color: #d1fae5;\n  margin: 0;\n}\n\n.ds-customer-name {\n  margin: 8px 0 0 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: #ecfeff;\n}\n\n.ds-customer-desc {\n  margin: 8px 0 0 0;\n  font-size: 15px;\n  color: #a7f3d0;\n}\n\n.ds-customer-action-bar {\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  gap: 12px;\n}\n\n.ds-customer-action-prompt {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.ds-continue-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  padding: 8px 16px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #0f172a;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n}\n\n.ds-continue-btn:hover {\n  background-color: #f1f5f9;\n}\n\n.ds-simulated-tip-card {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.05);\n  padding: 20px;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.5;\n}\n\n/* Simulated footer of secondary screen */\n.ds-simulated-footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.25);\n  padding: 12px 16px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.ds-simulated-footer-text {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.ds-simulated-footer-price {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n/* Control Row selectors (Touch / Display Only, Steps) */\n.ds-page-control-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 0 4px;\n  margin-top: 16px;\n}\n\n.ds-page-control-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.ds-control-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  padding: 8px 16px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.ds-control-btn-active {\n  border-color: #0f172a;\n  background-color: #0f172a;\n  color: #ffffff;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.ds-control-btn-inactive {\n  border-color: #e2e8f0;\n  background-color: #ffffff;\n  color: #475569;\n}\n\n.ds-control-btn-inactive:hover {\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.ds-dark .ds-control-btn-inactive {\n  border-color: rgba(255, 255, 255, 0.1);\n  background-color: #2b2c34;\n  color: #cbd5e1;\n}\n\n.ds-dark .ds-control-btn-inactive:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n  color: #ffffff;\n}\n\n.ds-dark .ds-control-btn-active {\n  border-color: #ffffff;\n  background-color: #ffffff;\n  color: #0f172a;\n}\n\n.ds-btn-icon {\n  height: 16px;\n  width: 16px;\n}\n\n.ds-flow-btn {\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  padding: 8px 16px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.ds-flow-btn-active {\n  border-color: #c7d2fe;\n  background-color: #e0e7ff;\n  color: #4338ca;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.ds-flow-btn-inactive {\n  border-color: #e2e8f0;\n  background-color: #ffffff;\n  color: #475569;\n}\n\n.ds-flow-btn-inactive:hover {\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.ds-dark .ds-flow-btn-inactive {\n  border-color: rgba(255, 255, 255, 0.1);\n  background-color: #2b2c34;\n  color: #cbd5e1;\n}\n\n.ds-dark .ds-flow-btn-inactive:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n  color: #ffffff;\n}\n\n/* Config cards in right pane */\n.ds-config-card {\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  background-color: rgba(255, 255, 255, 0.75);\n  padding: 24px;\n  box-shadow: 0 24px 60px -34px rgba(15, 23, 42, 0.35);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  margin-bottom: 24px;\n  box-sizing: border-box;\n}\n\n.ds-dark .ds-config-card {\n  border-color: rgba(255, 255, 255, 0.05);\n  background-color: rgba(43, 44, 52, 0.75);\n  box-shadow: 0 24px 60px -34px rgba(0, 0, 0, 0.5);\n}\n\n.ds-config-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.ds-config-icon-box {\n  display: flex;\n  height: 44px;\n  width: 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n}\n\n.ds-indigo-light {\n  background-color: #e0e7ff;\n  color: #4f46e5;\n}\n\n.ds-dark .ds-indigo-light {\n  background-color: rgba(79, 70, 229, 0.2);\n  color: #a5b4fc;\n}\n\n.ds-indigo-dark {\n  background-color: #4f46e5;\n  color: #ffffff;\n}\n\n.ds-slate-light {\n  background-color: #f1f5f9;\n  color: #475569;\n}\n\n.ds-dark .ds-slate-light {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #cbd5e1;\n}\n\n.ds-header-icon {\n  height: 20px;\n  width: 20px;\n}\n\n.ds-config-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.ds-dark .ds-config-title {\n  color: #ffffff;\n}\n\n.ds-config-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 15px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.ds-dark .ds-config-subtitle {\n  color: #94a3b8;\n}\n\n.ds-list-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ds-screen-option-card {\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  gap: 16px;\n  border-radius: 16px;\n  border: 1px solid transparent;\n  padding: 16px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.ds-screen-option-card-active {\n  border-color: #c7d2fe;\n  background-color: rgba(238, 242, 255, 0.8);\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n}\n\n.ds-screen-option-card-inactive {\n  border-color: #e2e8f0;\n  background-color: #ffffff;\n}\n\n.ds-screen-option-card-inactive:hover {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n}\n\n.ds-dark .ds-screen-option-card-inactive {\n  border-color: rgba(255, 255, 255, 0.1);\n  background-color: #2b2c34;\n}\n\n.ds-dark .ds-screen-option-card-inactive:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n  background-color: #1e1f25;\n}\n\n.ds-dark .ds-screen-option-card-active {\n  border-color: rgba(99, 102, 241, 0.4);\n  background-color: rgba(99, 102, 241, 0.1);\n}\n\n.ds-option-icon-box {\n  display: flex;\n  height: 44px;\n  width: 44px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n}\n\n.ds-option-svg {\n  height: 20px;\n  width: 20px;\n  color: inherit;\n}\n\n.ds-option-info {\n  min-width: 0;\n  flex: 1;\n}\n\n.ds-option-title-text {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.ds-dark .ds-option-title-text {\n  color: #ffffff;\n}\n\n.ds-option-desc-text {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.ds-dark .ds-option-desc-text {\n  color: #94a3b8;\n}\n\n/* Upload card dashed styling */\n.ds-upload-dashed-card {\n  margin-bottom: 16px;\n  border-radius: 24px;\n  border: 2px dashed #cbd5e1;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 24px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.ds-upload-dashed-card:hover {\n  background-color: #f1f5f9;\n}\n\n.ds-dark .ds-upload-dashed-card {\n  border-color: rgba(255, 255, 255, 0.2);\n  background-color: rgba(27, 28, 35, 0.7);\n}\n\n.ds-dark .ds-upload-dashed-card:hover {\n  background-color: #1e1f25;\n}\n\n.ds-upload-play-icon-wrap {\n  margin: 0 auto 12px auto;\n  display: flex;\n  height: 48px;\n  width: 48px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #ffffff;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n}\n\n.ds-dark .ds-upload-play-icon-wrap {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.ds-upload-svg {\n  height: 24px;\n  width: 24px;\n  color: #0860e6;\n}\n\n.ds-dark .ds-upload-svg {\n  color: #a5b4fc;\n}\n\n.ds-upload-title-text {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.ds-dark .ds-upload-title-text {\n  color: #ffffff;\n}\n\n.ds-upload-desc-text {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.ds-dark .ds-upload-desc-text {\n  color: #94a3b8;\n}\n\n/* Media loops buttons */\n.ds-media-option-btn {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 12px;\n  border-radius: 16px;\n  border: 1px solid transparent;\n  padding: 12px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-sizing: border-box;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n}\n\n.ds-media-option-btn-active {\n  border-color: #c7d2fe;\n  background-color: rgba(238, 242, 255, 0.8);\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\n}\n\n.ds-media-option-btn-inactive {\n  border-color: #e2e8f0;\n  background-color: #ffffff;\n}\n\n.ds-media-option-btn-inactive:hover {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n}\n\n.ds-dark .ds-media-option-btn-inactive {\n  border-color: rgba(255, 255, 255, 0.1);\n  background-color: #2b2c34;\n}\n\n.ds-dark .ds-media-option-btn-inactive:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n  background-color: #1e1f25;\n}\n\n.ds-dark .ds-media-option-btn-active {\n  border-color: rgba(99, 102, 241, 0.4);\n  background-color: rgba(99, 102, 241, 0.1);\n}\n\n/* Media preview thumbnail */\n.ds-media-preview-thumb {\n  width: 48px;\n  height: 48px;\n  border-radius: 16px;\n  flex-shrink: 0;\n}\n\n/* Gradients for thumbnails */\n.ds-grad-summer {\n  background: linear-gradient(135deg, #d946ef, #a855f7, #6366f1);\n}\n\n.ds-grad-breakfast {\n  background: linear-gradient(135deg, #fbbf24, #f97316, #f43f5e);\n}\n\n.ds-grad-chef {\n  background: linear-gradient(135deg, #34d399, #2dd4bf, #06b6d4);\n}\n\n/* Media details */\n.ds-media-info {\n  min-width: 0;\n  flex: 1;\n}\n\n.ds-media-title-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 0;\n}\n\n.ds-dark .ds-media-title-text {\n  color: #ffffff;\n}\n\n.ds-media-desc-text {\n  font-size: 12px;\n  color: #64748b;\n  margin: 4px 0 0 0;\n}\n\n.ds-dark .ds-media-desc-text {\n  color: #94a3b8;\n}\n\n.ds-check-svg {\n  width: 20px;\n  height: 20px;\n  color: #4f46e5;\n  flex-shrink: 0;\n}\n\n/* Display option switches */\n.ds-display-option-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 16px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.ds-dark .ds-display-option-row {\n  border-color: rgba(255, 255, 255, 0.1);\n  background-color: rgba(27, 28, 35, 0.7);\n}\n\n.ds-display-option-row:hover {\n  border-color: #cbd5e1;\n}\n\n.ds-dark .ds-display-option-row:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.ds-opt-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.ds-dark .ds-opt-title {\n  color: #ffffff;\n}\n\n.ds-opt-desc {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.ds-dark .ds-opt-desc {\n  color: #94a3b8;\n}\n\n.ds-option-switch {\n  position: relative;\n  display: inline-flex;\n  height: 20px;\n  width: 36px;\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: background-color 0.2s;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.ds-option-switch-active {\n  background-color: #0860e6;\n}\n\n.ds-option-switch-inactive {\n  background-color: #cbd5e1;\n}\n\n.ds-dark .ds-option-switch-inactive {\n  background-color: #475569;\n}\n\n.ds-option-switch-thumb {\n  pointer-events: none;\n  display: block;\n  height: 16px;\n  width: 16px;\n  border-radius: 9999px;\n  background-color: #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.ds-option-switch-thumb-active {\n  transform: translateX(16px);\n}\n\n.ds-option-switch-thumb-inactive {\n  transform: translateX(0);\n}\n\n/* Flow Guidance section styling */\n.ds-flow-guidance-card {\n  border-radius: 28px;\n  border: 1px solid #e2e8f0;\n  background-color: #020617;\n  padding: 24px;\n  color: #ffffff;\n  box-shadow: 0 24px 60px -34px rgba(15, 23, 42, 0.58);\n  box-sizing: border-box;\n}\n\n.ds-dark .ds-flow-guidance-card {\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.ds-guidance-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.ds-guidance-icon-box {\n  display: flex;\n  height: 44px;\n  width: 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.ds-star-svg {\n  height: 20px;\n  width: 20px;\n  color: #fcd34d;\n}\n\n.ds-guidance-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.ds-guidance-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.ds-guidance-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ds-guidance-item {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.05);\n  padding: 12px 16px;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.75);\n  line-height: 1.5;\n}\n\n/* Simulated screen layouts and preview card states */\n\n.ds-promo-card-wrap {\n  position: relative;\n  overflow: hidden;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 24px;\n  min-height: 300px;\n  box-sizing: border-box;\n}\n\n.ds-promo-card-bg-gradient {\n  position: absolute;\n  inset: 0;\n  opacity: 0.95;\n  pointer-events: none;\n}\n\n.ds-promo-card-bg-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    140deg,\n    rgba(255, 255, 255, 0.16),\n    transparent 42%,\n    rgba(15, 23, 42, 0.34)\n  );\n  pointer-events: none;\n}\n\n.ds-promo-card-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  min-height: 252px;\n}\n\n.ds-promo-now-playing-badge {\n  display: inline-flex;\n  align-self: flex-start;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 2px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.ds-promo-main-title {\n  margin: 20px 0 12px 0;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #ffffff;\n}\n\n.ds-promo-sub-text {\n  margin: 0 0 24px 0;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.85);\n  line-height: 1.45;\n}\n\n.ds-promo-media-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background-color: rgba(0, 0, 0, 0.15);\n  padding: 12px 16px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.ds-promo-media-tag {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0;\n}\n\n.ds-promo-media-name {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n}\n\n.ds-promo-media-resolution {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.ds-bullet-cards-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.ds-bullet-card {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.06);\n  padding: 16px 32px;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.75);\n  line-height: 1.45;\n}\n\n.ds-loyalty-prompt-card {\n  border-radius: 24px;\n  border: 1px solid rgba(34, 211, 238, 0.2);\n  background-color: rgba(34, 211, 238, 0.12);\n  padding: 20px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.ds-loyalty-prompt-badge {\n  display: inline-flex;\n  border-radius: 9999px;\n  border: 1px solid rgba(34, 211, 238, 0.2);\n  background-color: rgba(34, 211, 238, 0.1);\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.28em;\n  color: #cffafe;\n  margin-bottom: 12px;\n}\n\n.ds-loyalty-prompt-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.ds-loyalty-prompt-desc {\n  font-size: 15px;\n  color: rgba(207, 250, 254, 0.75);\n  margin: 8px 0 0 0;\n  line-height: 1.4;\n}\n\n.ds-loyalty-qr-box {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  margin-top: 16px;\n}\n\n.ds-loyalty-qr-svg {\n  width: 32px;\n  height: 32px;\n  color: #a5f3fc;\n  flex-shrink: 0;\n}\n\n.ds-loyalty-qr-text {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ds-display-only-note-card {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.05);\n  padding: 20px;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.5;\n  box-sizing: border-box;\n}\n\n.ds-display-read-only-notice-block {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.45;\n  margin-bottom: 16px;\n}\n\n/* Keypad updates */\n.ds-keypad-btn:active {\n  transform: scale(0.97);\n}\n\n/* Cart Item layouts */\n.ds-cart-order-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.ds-cart-order-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n}\n\n.ds-cart-item-thumb {\n  width: 56px;\n  height: 56px;\n  flex-shrink: 0;\n  border-radius: 16px;\n}\n\n.ds-cart-thumb-1 {\n  background: linear-gradient(135deg, #fde68a, #fed7aa);\n}\n\n.ds-cart-thumb-2 {\n  background: linear-gradient(135deg, #fecdd3, #fed7aa);\n}\n\n.ds-cart-thumb-3 {\n  background: linear-gradient(135deg, #bae6fd, #cffafe);\n}\n\n.ds-cart-thumb-4 {\n  background: linear-gradient(135deg, #d9f99d, #a7f3d0);\n}\n\n.ds-cart-thumb-5 {\n  background: linear-gradient(135deg, #f5d0fe, #fecdd3);\n}\n\n.ds-cart-item-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.ds-cart-item-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ds-cart-item-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ds-cart-item-price {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.ds-cart-item-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-top: 4px;\n}\n\n.ds-price-breakdown-card {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.25);\n  padding: 16px;\n}\n\n.ds-price-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 8px;\n}\n\n.ds-price-row:last-child {\n  margin-bottom: 0;\n}\n\n.ds-total-row {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-top: 12px;\n}\n\n.ds-cart-linked-loyalty-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 16px;\n  border: 1px solid rgba(52, 211, 153, 0.2);\n  background-color: rgba(16, 185, 129, 0.12);\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  cursor: pointer;\n}\n\n.ds-loyalty-linked-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #a7f3d0;\n  margin: 0;\n}\n\n.ds-loyalty-linked-desc {\n  font-size: 12px;\n  color: rgba(209, 250, 229, 0.7);\n  margin: 4px 0 0 0;\n}\n\n.ds-loyalty-linked-badge {\n  inline-flex: true;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 2px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n/* Payment Flow layouts */\n.ds-payment-methods-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.ds-pay-method-btn {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 16px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 88px;\n  box-sizing: border-box;\n}\n\n.ds-pay-method-btn-active {\n  border-color: rgba(34, 211, 238, 0.3);\n  background-color: rgba(34, 211, 238, 0.15);\n  color: #ecfeff;\n}\n\n.ds-pay-method-btn-inactive {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.ds-pay-method-btn-inactive:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.ds-pay-method-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.ds-pay-method-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.ds-pay-method-icon {\n  width: 16px;\n  height: 16px;\n  color: inherit;\n}\n\n.ds-pay-method-desc {\n  font-size: 12px;\n  color: inherit;\n  opacity: 0.7;\n  margin: 8px 0 0 0;\n}\n\n.ds-tips-selection-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.ds-tip-btn {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 12px 16px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.ds-tip-btn-active {\n  border-color: rgba(34, 211, 238, 0.3);\n  background-color: rgba(34, 211, 238, 0.15);\n  color: #ecfeff;\n}\n\n.ds-tip-btn-inactive {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.ds-tip-btn-inactive:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.ds-tip-percent {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.ds-tip-amount {\n  font-size: 12px;\n  color: inherit;\n  opacity: 0.7;\n  margin: 4px 0 0 0;\n}\n\n/* Scan & Pay components */\n.ds-scan-qr-wrap {\n  width: 44px;\n  height: 44px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ds-scan-qr-svg-icon {\n  width: 24px;\n  height: 24px;\n  color: #a5f3fc;\n}\n\n.ds-qr-code-display-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 24px;\n}\n\n.ds-qr-code-frame {\n  padding: 16px;\n  background-color: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);\n}\n\n.ds-qr-code-image {\n  display: block;\n}\n\n.ds-qr-scan-hint {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n  margin-top: 12px;\n  text-align: center;\n}\n\n/* Success layout components */\n.ds-simulated-success-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 380px;\n  box-sizing: border-box;\n}\n\n.ds-success-checkmark-wrap {\n  border-radius: 9999px;\n  border: 1px solid rgba(52, 211, 153, 0.2);\n  background-color: rgba(16, 185, 129, 0.12);\n  padding: 24px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.ds-success-check-svg {\n  width: 56px;\n  height: 56px;\n  color: #6ee7b7;\n}\n\n.ds-success-badge-tag {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.32em;\n  color: #a7f3d0;\n  margin: 20px 0 0 0;\n}\n\n.ds-success-heading {\n  font-size: 36px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 8px 0 0 0;\n}\n\n.ds-success-sub-desc {\n  max-width: 448px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.65);\n  margin: 12px 0 0 0;\n  line-height: 1.4;\n}\n\n.ds-success-details-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  width: 100%;\n  max-width: 448px;\n  margin-top: 24px;\n}\n\n.ds-success-detail-box {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.06);\n  padding: 16px;\n}\n\n.ds-success-detail-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0;\n}\n\n.ds-success-detail-val {\n  font-size: 20px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 4px 0 0 0;\n}\n\n/* Header styles matching user reference markup */\n.ds-hdr-wrap {\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  height: 64px;\n  max-width: 1152px;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 24px;\n  padding-right: 24px;\n  box-sizing: border-box;\n}\n\n.ds-hdr-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.ds-hdr-back {\n  display: flex;\n  height: 40px;\n  width: 40px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #475569;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: all 0.2s;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.ds-hdr-back:hover {\n  transform: translateY(-2px);\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.ds-hdr-title {\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #020617;\n  margin: 0;\n}\n\n.ds-dark .ds-hdr-title {\n  color: #ffffff;\n}\n\n.ds-hdr-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 8px 16px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n}\n\n.ds-dark .ds-hdr-right {\n  border-color: rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.ds-hdr-toggle-label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.ds-dark .ds-hdr-toggle-label {\n  color: #cbd5e1;\n}\n\n.ds-hdr-switch {\n  position: relative;\n  display: inline-flex;\n  height: 20px;\n  width: 36px;\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: background-color 0.2s;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.ds-hdr-switch[data-state=\"checked\"] {\n  background-color: #0860e6;\n}\n\n.ds-hdr-switch[data-state=\"unchecked\"] {\n  background-color: #cbd5e1;\n}\n\n.ds-dark .ds-hdr-switch[data-state=\"unchecked\"] {\n  background-color: #475569;\n}\n\n.ds-hdr-switch-thumb {\n  pointer-events: none;\n  display: block;\n  height: 16px;\n  width: 16px;\n  border-radius: 9999px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  transition: transform 0.2s;\n}\n\n.ds-hdr-switch-thumb[data-state=\"checked\"] {\n  transform: translateX(16px);\n}\n\n.ds-hdr-switch-thumb[data-state=\"unchecked\"] {\n  transform: translateX(0);\n}\n\n/* Paused status badge overlay styling */\n.ds-status-paused {\n  border-color: rgba(255, 255, 255, 0.15) !important;\n  background-color: rgba(255, 255, 255, 0.08) !important;\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\n/* Display off layout screen */\n.ds-display-off-container {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  text-align: center;\n  color: #ffffff;\n  z-index: 5;\n  box-sizing: border-box;\n}\n\n.ds-display-off-icon-wrap {\n  display: flex;\n  height: 80px;\n  width: 80px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  box-sizing: border-box;\n}\n\n.ds-display-off-icon {\n  height: 40px;\n  width: 40px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.ds-display-off-text-group {\n  margin-top: 8px;\n}\n\n.ds-display-off-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.ds-display-off-desc {\n  max-width: 448px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.5;\n  margin: 8px auto 0 auto;\n}\n\n/* New Scan & Pay Section Styles */\n.ds-scan-pay-layout {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 1.15fr 0.85fr;\n}\n\n@media (max-width: 991px) {\n  .ds-scan-pay-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ds-payment-flow-card {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  background-color: rgba(255, 255, 255, 0.06) !important;\n  padding: 20px !important;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ds-payment-flow-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.ds-payment-flow-subtitle {\n  font-size: 12px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.32em;\n  color: rgba(255, 255, 255, 0.55) !important;\n  margin: 0 !important;\n}\n\n.ds-payment-flow-title {\n  margin: 8px 0 0 0 !important;\n  font-size: 24px !important;\n  font-weight: 600 !important;\n  color: #ffffff !important;\n}\n\n.ds-payment-flow-desc {\n  margin: 4px 0 0 0 !important;\n  font-size: 14px !important;\n  color: rgba(255, 255, 255, 0.6) !important;\n  line-height: 1.5 !important;\n}\n\n.ds-payment-flow-wallet-icon {\n  height: 32px;\n  width: 32px;\n  color: #67e8f9;\n  flex-shrink: 0;\n}\n\n.ds-scan-pay-qr-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 28px;\n  border: 1px solid rgba(34, 211, 238, 0.2);\n  background-color: rgba(34, 211, 238, 0.1);\n  padding: 24px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.ds-scan-pay-qr-frame {\n  margin-bottom: 20px;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background-color: #ffffff;\n  padding: 16px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 20px 50px -20px rgba(255, 255, 255, 0.4);\n  box-sizing: border-box;\n}\n\n.ds-scan-pay-qr-code-svg {\n  height: 176px;\n  width: 176px;\n  color: #020617;\n}\n\n.ds-scan-pay-qr-subtitle {\n  font-size: 12px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.32em;\n  color: rgba(207, 250, 254, 0.7) !important;\n  margin: 0 !important;\n}\n\n.ds-scan-pay-qr-title {\n  margin: 8px 0 0 0 !important;\n  font-size: 30px !important;\n  font-weight: 600 !important;\n  color: #ffffff !important;\n}\n\n.ds-scan-pay-qr-desc {\n  margin: 8px 0 0 0 !important;\n  max-width: 448px;\n  font-size: 14px !important;\n  color: rgba(236, 254, 255, 0.8) !important;\n  line-height: 1.5 !important;\n}\n\n.ds-scan-pay-instruction-box {\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  text-align: left;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.ds-scan-pay-mini-qr-icon {\n  height: 32px;\n  width: 32px;\n  color: #a5f3fc;\n  flex-shrink: 0;\n}\n\n.ds-instruction-title {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: #ffffff !important;\n  margin: 0 !important;\n}\n\n.ds-instruction-subtitle {\n  font-size: 12px !important;\n  color: rgba(255, 255, 255, 0.6) !important;\n  margin: 4px 0 0 0 !important;\n}\n\n.ds-scan-pay-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ds-sidebar-price-breakdown {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: rgba(0, 0, 0, 0.25);\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.ds-checkout-notes-card {\n  padding: 20px !important;\n}\n\n.ds-checkout-notes-list {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ds-checkout-note-item {\n  border-radius: 16px !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  background-color: rgba(0, 0, 0, 0.15) !important;\n  padding: 12px 16px !important;\n  font-size: 14px !important;\n  color: rgba(255, 255, 255, 0.75) !important;\n  line-height: 1.5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
